import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type { AttachmentDto, AuditLogDto } from '@/types/attachment.types';

export const attachmentApi = {
  // ── Document Attachments ────────────────────────────────────────────────────

  /** GET /api/v1/document-attachments?entityName=X&entityId=Y */
  getByEntity: (entityName: string, entityId: string) =>
    apiClient.get<ApiResponse<AttachmentDto[]>>('/document-attachments', {
      params: { entityName, entityId },
    }),

  /** POST /api/v1/document-attachments — multipart form upload */
  upload: (
    entityName: string,
    entityId:   string,
    file:       File,
    category?:  string,
    remarks?:   string,
  ) => {
    const form = new FormData();
    form.append('entityName', entityName);
    form.append('entityId',   entityId);
    form.append('file',       file);
    if (category) form.append('category', category);
    if (remarks)  form.append('remarks',  remarks);
    // Do NOT manually set Content-Type — browser sets it with boundary automatically
    return apiClient.post<ApiResponse<{ id: string }>>('/document-attachments', form);
  },

  /** Returns the download URL for a given attachment (direct browser link) */
  getDownloadUrl: (id: string): string =>
    `${apiClient.defaults.baseURL ?? ''}/document-attachments/${id}/download`,

  /** DELETE /api/v1/document-attachments/{id} — soft delete */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/document-attachments/${id}`),
};

// ── Audit Logs ────────────────────────────────────────────────────────────────

export const auditLogApi = {
  /** GET /api/v1/audit-logs?entityName=X&entityId=Y&pageNumber=1&pageSize=20 */
  getByEntity: (
    entityName: string,
    entityId:   string,
    pageNumber = 1,
    pageSize   = 20,
  ) =>
    apiClient.get<ApiResponse<PagedResult<AuditLogDto>>>('/audit-logs', {
      params: { entityName, entityId, pageNumber, pageSize },
    }),
};
